<template>
  <v-menu
    ref="menu"
    v-model="opened"
    light
    :close-on-content-click="false"
    :nudge-right="40"
    transition="scale-transition"
    offset-y
    min-width="290px"
    menu-props="light"
  >
    <template #activator="{ on }">
      <v-text-field
        v-model="newValue"
        color="info"
        prepend-icon="event"
        :rules="field.rules"
        :hint="field.helpText"
        readonly
        background-color="secondary"
        :label="field.label"
        clearable
        v-on="on"
      />
    </template>

    <component
      :is="componentType"
      v-if="showDatePicker"
      v-bind="currentProperties()"
      v-model="newValue"
      @input="opened = false"
    />
  </v-menu>
</template>

<script setup>
import { ref, watch } from 'vue';

// eslint-disable-next-line no-undef
const emit = defineEmits(['input']);

// eslint-disable-next-line no-undef
const props = defineProps({
  field: { type: Object, default: () => { } },
  value: { type: [Array, Number, String], default: null }
});

const formatDate = date => date && date.split('T')[0];

const newValue = ref(formatDate(props.value));
const opened = ref(false);
const componentType = ref('v-date-picker');
const showDatePicker = ref(true);

const currentProperties = () => {
  const properties = { color: 'info' };

  if (props.field.readonly) {
    showDatePicker.value = false;
  }

  switch (props.field.viewType) {
    case 'Date Picker':
      componentType.value = 'v-date-picker';
      properties['no-title'] = true;
      properties.scrollable = true;
      properties.locale = 'fr-FR';
      break;
    case 'Time Picker':
      componentType.value = 'v-time-picker';
      properties['full-width'] = true;
      properties.format = '24hr';
      break;
    default:
  }

  return properties;
};

watch(newValue, value => {
  emit('input', value);
});

</script>

<style lang="scss" scoped>

</style>
